import type { ReactNode } from "react";
import { CheckCircle2, Lock } from "lucide-react";
import { formatPhp } from "../lib/money";

// Contract and purchase parents retain release eligibility and settlement ownership.
export function MilestoneRow({ label, amount, released, detail, children }: {
  label: string;
  amount: number;
  released: boolean;
  detail?: ReactNode;
  children: ReactNode;
}) {
  return <div className="flex items-center justify-between gap-3 rounded-lg border border-line p-3">
    <div className="min-w-0 flex-1">
      <div className="flex min-w-0 items-center gap-2">
        {released ? <CheckCircle2 className="h-4 w-4 shrink-0 text-brand-green" /> : <Lock className="h-4 w-4 shrink-0 text-mut" />}
        <span className="min-w-0 break-words text-sm text-navy sm:truncate" title={label}>{label}</span>
      </div>
      {detail && <div className="ml-6 mt-1 text-xs text-mut">{detail}</div>}
    </div>
    <div className="flex shrink-0 items-center gap-3"><strong className="text-sm text-navy">{formatPhp(amount)}</strong>{children}</div>
  </div>;
}
